(ns shared.core.amelia-light.components.tooltip
  (:require [shared.core.components.tooltip :as tooltip]
            [shared.core.style :as style]
            [shared.core.util :as util]))

(style/add-css [".tippy-box[data-theme='amelia-light']"
                {:background-color "#2F373D"
                 :border "1px solid #444B50"
                 :border-radius "6px"
                 :box-shadow "0 2px 4px 0 rgba(0, 0, 0, 0.03), 0 6px 18px 0 rgba(0, 0, 0, 0.08)"}]
               [".tippy-box[data-theme='amelia-light'] *"
                {:color "rgba(255, 255, 255, 0.80)"}]
               [".tippy-box[data-theme='amelia-light']>.tippy-arrow"
                {:color "#2F373D"}]
               [".tippy-box[data-theme='amelia-light']>.tippy-arrow:before"
                {:color "#2F373D"
                 :transform "scale(1.4)"
                 :transform-origin :center}])

(defn tooltip [{:keys [tooltip-container-style arrow?] :as args}]
  [tooltip/tooltip (assoc args :theme "amelia-light"
                               :tooltip-container-style (merge {:font-size 12
                                                                :line-height 1.5
                                                                :padding "11px 15px"}
                                                               tooltip-container-style)
                               :arrow? (if (nil? arrow?) true arrow?))])
